import { SoccerDataWithPopupStoreType } from '@sportworld/js-sdk/src/types/storeTypes/soccerDataStoreTypes'

import { StateCreatorType } from '@/types/storeTypes/storeType'

const soccerDataStore: StateCreatorType<SoccerDataWithPopupStoreType> = (
  set,
) => ({
  matches: [],
  division: [],
  divisionPopup: {
    division: [],
    pageId: null,
    prevDivision: null,
  },
  tournamentCalendar: null,
  loading: {
    matches: false,
    standings: false,
  },
  loadingPopup: {
    standings: false,
  },
  setMatches: (matches) =>
    set(
      (state) => void (state.soccerData.matches = matches),
      false,
      'setMatches',
    ),
  setDivision: (division) =>
    set(
      (state) => void (state.soccerData.division = division),
      false,
      'setDivision',
    ),
  setDivisionPopup: (division) =>
    set(
      (state) => {
        const currentPageId = state.popup.pagePopup?.id
        const currentDivisionPopup = state.soccerData.divisionPopup

        if (currentDivisionPopup.pageId === currentPageId) {
          currentDivisionPopup.division = division
        } else {
          state.soccerData.divisionPopup = {
            division,
            pageId: currentPageId || null,
            prevDivision: currentDivisionPopup,
          }
        }
      },
      false,
      'setDivisionPopup',
    ),
  openPrevDivisionPopup: () =>
    set(
      (state) => {
        if (state.soccerData.divisionPopup.prevDivision) {
          state.soccerData.divisionPopup =
            state.soccerData.divisionPopup.prevDivision
        }
      },
      false,
      'openPrevDivisionPopup',
    ),
  closeDivisionPopup: () =>
    set(
      (state) => {
        state.soccerData.divisionPopup = {
          division: [],
          pageId: null,
          prevDivision: null,
        }
      },
      false,
      'closeDivisionPopup',
    ),
  setLoading: (key, isLoading) =>
    set(
      (state) => void (state.soccerData.loading[key] = isLoading),
      false,
      'setLoading',
    ),
  setLoadingPopup: (key, isLoading) =>
    set(
      (state) => void (state.soccerData.loadingPopup[key] = isLoading),
      false,
      'setLoadingPopup',
    ),
  setTournamentCalendar: (calendar) =>
    set(
      (state) => void (state.soccerData.tournamentCalendar = calendar),
      false,
      'setTournamentCalendar',
    ),
})

export default soccerDataStore
